import { isInternetExplorer } from '~/util/featureDetect'

export default ({ route, redirect }) => {
    if (isInternetExplorer() && route.path !== '/browser-outdated') {
        console.log('Internet Explorer detected, redirecting to browser gate')
        return redirect('/browser-outdated')
    }
}